import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_2 = {
  title: `Thanks to <span style="color: #92D1FF;">Infosys Zero Data \nEngineering platform</span>, Vignesh can rapidly \nsynchronize or transform customer data \nautomatically using <span style="color: #92D1FF;">AI-driven real-time \npipeline and processing</span>, without the need \nfor any manual coding.`,
  subtitle: "Data STREAMS demo",
  label: [
    {
      iconPath: "start.png",
      text: "AI-first real-ime data pipeline and processing",
    },
  ],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(207),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(205),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_02_computer.png",
          imageStyle: {
            position: "absolute",
            right: "73.59px",
            bottom: "255.58px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_02_list.png",
          imageStyle: {
            position: "absolute",
            right: "394.62px",
            bottom: "160.56px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_02_bubble_1.png",
          imageStyle: { position: "absolute", right: "74px", bottom: "573px" },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_02_bubble_2.png",
          imageStyle: { position: "absolute", right: "74px", bottom: "476px" },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_02_bubble_3.png",
          imageStyle: { position: "absolute", right: "194px", bottom: "394px" },
        },
      ]}
      pageNumber={206}
    />
  ),
};
